import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { Col, Container, Row } from 'reactstrap';
import newtheme from '../../newtheme';
import { ILandingPageContentUsp } from '../../domaindriven/landing/types/ILandingPageContentUsp';

interface IProps {
    sectionData: ILandingPageContentUsp;
}

class LandingEditorialInsights extends React.Component<IProps> {
    public renderRegularV2 = () => {
        const { sectionData } = this.props;
        return (
            <div className={css(publisherEmbedStyles.main)}>
                <Container>
                    <Row className={css(publisherEmbedStyles.insightsContainer)}>
                        <Col xs={12} sm={7} lg={8}>
                            <Row>
                                <Col lg={10} xl={11} className={css(publisherEmbedStyles.insightWrapper)} id="insight1">
                                    <h2 className={css(styles.insightHeader)}>{sectionData.title}</h2>
                                    {sectionData.points.map((point, index) => (
                                        <p key={index} className={css(styles.insightPoint)}>
                                            {point}
                                        </p>
                                    ))}

                                    <img
                                        alt="Screenshot of mobile app home screen"
                                        src={sectionData.image}
                                        className={css(styles.mobileImage)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={5} lg={4} className={css(styles.rightImageWrapper)}>
                            <img
                                alt="Screenshot of mobile app home screen"
                                src={sectionData.image}
                                className={css(styles.rightImage, publisherEmbedStyles.rightImageWithoutPosition)}
                                id="imageElement"
                            />
                        </Col>
                    </Row>
                    <Row />
                </Container>
            </div>
        );
    };

    public render() {
        return this.renderRegularV2();
    }
}

const publisherEmbedStyles = StyleSheet.create({
    insightsContainer: {},
    main: {
        [newtheme.cssBreakpoints.medium]: {
            paddingTop: 150,
        },
        [newtheme.cssBreakpoints.small]: {
            paddingTop: 100,
        },
        [newtheme.cssBreakpoints.tiny]: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        paddingTop: 200,
        paddingBottom: 100,
        backgroundColor: 'white',
        color: 'black',
    },
    insightWrapper: {
        [newtheme.cssBreakpoints.large]: {
            paddingTop: 50,
        },
        [newtheme.cssBreakpoints.medium]: {
            paddingTop: 25,
        },
        [newtheme.cssBreakpoints.small]: {
            paddingTop: 40,
        },
        [newtheme.cssBreakpoints.tiny]: {
            margin: 0,
            marginBottom: 50,
            alignItems: 'center',
            textAlign: 'center',
            width: '86%',
            marginLeft: '7%',
        },
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 100,
    },
    rightImageWithoutPosition: {
        position: 'initial',
        top: 'auto',
        transform: 'none',
    },
});

const styles = StyleSheet.create({
    main: {
        [newtheme.cssBreakpoints.medium]: {
            paddingTop: 400,
            paddingBottom: 100,
        },
        [newtheme.cssBreakpoints.small]: {
            paddingTop: 350,
            paddingBottom: 100,
        },
        [newtheme.cssBreakpoints.tiny]: {
            paddingTop: 0,
            paddingBottom: 30,
        },
        backgroundColor: 'white',
        color: 'black',
        paddingTop: 500,
        paddingBottom: 0,
    },
    insightsContainer: {
        [newtheme.cssBreakpoints.tiny]: {
            marginBottom: 0,
        },
        position: 'relative',
        marginBottom: -200,
    },
    hide: {
        display: 'none',
    },
    insightWrapper: {
        [newtheme.cssBreakpoints.large]: {},
        [newtheme.cssBreakpoints.medium]: {},
        [newtheme.cssBreakpoints.small]: {
            marginTop: -150,
            marginBottom: 350,
        },
        [newtheme.cssBreakpoints.tiny]: {
            margin: 0,
            marginBottom: 50,
            alignItems: 'center',
            textAlign: 'center',
            width: '90%',
            marginLeft: '5%',
        },
        [newtheme.cssBreakpoints.smallerThanTiny]: {
            width: '94%',
            marginLeft: '3%',
        },
        [newtheme.cssBreakpoints.largeWidthMediumHeight]: {
            marginLeft: 100,
        },
        display: 'flex',
        flexDirection: 'column',
        marginTop: -200,
        marginBottom: 500,
    },
    insightWrapperFinal: {
        [newtheme.cssBreakpoints.medium]: {
            marginBottom: 350,
        },
        [newtheme.cssBreakpoints.small]: {
            marginBottom: 250,
        },
        [newtheme.cssBreakpoints.tiny]: {
            marginBottom: 0,
        },
        [newtheme.cssBreakpoints.largeWidthLargeHeight]: {
            marginBottom: 250,
        },
        [newtheme.cssBreakpoints.largeWidthMediumHeight]: {
            marginBottom: 200,
        },
        marginBottom: 400,
    },
    insightIcon: {
        [newtheme.cssBreakpoints.medium]: {
            height: 40,
            width: 40,
            marginBottom: 15,
        },
        [newtheme.cssBreakpoints.small]: {
            height: 40,
            width: 40,
            marginBottom: 10,
        },
        [newtheme.cssBreakpoints.tiny]: {
            height: 55,
            width: 55,
            marginBottom: 20,
        },
        height: 50,
        width: 50,
        marginBottom: 25,
    },
    insightHeader: {
        [newtheme.cssBreakpoints.large]: {
            fontSize: 45,
        },
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 37,
            marginBottom: 15,
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 25,
            marginBottom: 10,
        },
        [newtheme.cssBreakpoints.tiny]: {
            fontSize: 24,
        },
        [newtheme.cssBreakpoints.smallerThanTiny]: {
            fontSize: 22,
        },
        fontSize: 48,
        fontWeight: 500,
        marginBottom: 20,
    },
    insightPoint: {
        [newtheme.cssBreakpoints.large]: {
            fontSize: 22,
        },
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 20,
            marginBottom: 20,
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 14,
            marginBottom: 15,
        },
        [newtheme.cssBreakpoints.tiny]: {
            fontSize: 16,
            marginBottom: 12,
        },
        [newtheme.cssBreakpoints.minuscule]: {
            fontSize: 15,
        },
        fontSize: 24,
        fontWeight: 400,
        marginBottom: 25,
    },
    rightImageWrapper: {},
    rightImage: {
        [newtheme.cssBreakpoints.large]: {
            height: 611,
            width: 282,
        },
        [newtheme.cssBreakpoints.medium]: {
            height: 500,
            width: 231,
        },
        [newtheme.cssBreakpoints.largeWidthLargeHeight]: {
            height: 500,
            width: 231,
        },
        [newtheme.cssBreakpoints.largeWidthMediumHeight]: {
            height: 407,
            width: 188,
            marginLeft: -50,
        },
        [newtheme.cssBreakpoints.small]: {
            height: 407,
            width: 188,
        },
        [newtheme.cssBreakpoints.tiny]: {
            display: 'none',
        },
        position: 'sticky',
        top: 'calc(50% + 20px)',
        transform: 'translateY(-50%)',
        display: 'block',
        height: 715,
        width: 330,
        objectFit: 'cover',
    },
    mobileImage: {
        [newtheme.cssBreakpoints.tiny]: {
            display: 'block',
            width: '80%',
            maxWidth: 250,
            marginTop: 25,
            marginBottom: 50,
        },
        display: 'none',
    },
});

export default LandingEditorialInsights;
